import React from "react";
import {
  Button,
  Card,
  CardContent,
  Box,
  Typography,
  Grid,
  Container,
} from "@mui/material";
import { PlayArrow, Check } from "@mui/icons-material";

export default function Quotes() {
  return (
    <Box sx={{ width: "100%", mt: "100px" }}>
      {/* Testimonials Section */}
      <Box sx={{ px: { xs: 2, md: 4, lg: 8 }, py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }}>
            {/* Testimonial 1 */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: { xs: "1.125rem", md: "1.25rem" },
                    fontWeight: "medium",
                    lineHeight: 1.75,
                    color: "text.primary",
                  }}
                >
                  "Employers are expecting AI fluency. It may not be on the job
                  description, but it's going to be something that shows up
                  somehow in the interview"
                </Typography>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                >
                  <Typography
                    sx={{ fontWeight: "semibold", color: "text.primary" }}
                  >
                    Daniel Shapero
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "text.secondary" }}
                  >
                    COO at LinkedIn
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Testimonial 2 */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: { xs: "1.125rem", md: "1.25rem" },
                    fontWeight: "medium",
                    lineHeight: 1.75,
                    color: "text.primary",
                  }}
                >
                  "Nontechnical skills will be crucial in building resilient,
                  AI-enhanced teams. As AI handles more routine tasks, companies
                  will focus even more on developing human nontechnical skills
                  like creativity and values-aligned thinking—qualities that
                  machines simply can't replicate"
                </Typography>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                >
                  <Typography
                    sx={{ fontWeight: "semibold", color: "text.primary" }}
                  >
                    Jennie Rogerson
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "text.secondary" }}
                  >
                    Global Head of People at Canva
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Testimonial 3 */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: { xs: "1.125rem", md: "1.25rem" },
                    fontWeight: "medium",
                    lineHeight: 1.75,
                    color: "text.primary",
                  }}
                >
                  "The future of hiring lies in prioritising skills and
                  adaptability. As business models evolve, credentials and past
                  experiences will take a backseat to what individuals can truly
                  achieve."
                </Typography>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                >
                  <Typography
                    sx={{ fontWeight: "semibold", color: "text.primary" }}
                  >
                    Richard Lobo
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "text.secondary" }}
                  >
                    Chief People Officer at Tech Mahindra
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* What Do we Offer Section */}
      <Box sx={{ px: { xs: 2, md: 4, lg: 8 }, py: 6, bgcolor: "grey.50" }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "1.875rem", md: "2.25rem", lg: "3rem" },
              fontWeight: "bold",
              color: "text.primary",
              mb: 6,
            }}
          >
            What Do we Offer?
          </Typography>

          <Grid container spacing={{ xs: 4, lg: 8 }} alignItems="center">
            {/* Video Player */}
            <Grid item xs={12} lg={6}>
              <Box sx={{ position: "relative" }}>
                {/* Video Player Container */}
                <Box
                  sx={{
                    backgroundColor: "black",
                    borderRadius: "24px",
                    p: 4,
                    aspectRatio: "16/9",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <iframe
                    // ref={videoRef}
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/wKOdkit9dPQ?enablejsapi=1`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  ></iframe>

                  {/* Play Button */}
                  {/* <Button
                                onClick={toggleVideo}
                                size="large"
                                sx={{
                                  backgroundColor: "transparent",
                                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                                  border: 0,
                                  p: 3,
                                  borderRadius: "50%",
                                  minWidth: "auto",
                                }}
                              >
                                {isPlaying ? (
                                  <Pause sx={{ width: 48, height: 48, color: "white" }} />
                                ) : (
                                  <PlayArrow
                                    sx={{ width: 48, height: 48, color: "white", ml: 0.5 }}
                                  />
                                )}
                              </Button> */}

                  {/* Progress Bar */}
                  {/* <Box
                                sx={{
                                  position: "absolute",
                                  bottom: 24,
                                  left: 24,
                                  right: 24,
                                }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                                    height: 8,
                                    borderRadius: "9999px",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleProgressClick}
                                >
                                  <Box
                                    sx={{
                                      backgroundColor: "white",
                                      height: 8,
                                      borderRadius: "9999px",
                                      position: "relative",
                                      width: `${progress}%`,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        right: 0,
                                        top: "50%",
                                        transform: "translateX(50%) translateY(-50%)",
                                        width: 16,
                                        height: 16,
                                        backgroundColor: "white",
                                        borderRadius: "50%",
                                      }}
                                    ></Box>
                                  </Box>
                                </Box>
                              </Box> */}
                </Box>
              </Box>
            </Grid>

            {/* Features List */}
            <Grid item xs={12} lg={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: 24,
                      height: 24,
                      bgcolor: "success.main",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 0.5,
                    }}
                  >
                    <Check sx={{ width: 16, height: 16, color: "white" }} />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "1.125rem", md: "1.25rem" },
                      color: "text.primary",
                      lineHeight: 1.75,
                    }}
                  >
                    Human Centric Skill Assessment through our advance Interview
                    Assessment
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: 24,
                      height: 24,
                      bgcolor: "success.main",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 0.5,
                    }}
                  >
                    <Check sx={{ width: 16, height: 16, color: "white" }} />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "1.125rem", md: "1.25rem" },
                      color: "text.primary",
                      lineHeight: 1.75,
                    }}
                  >
                    Reports and Analysis on the overall student performance and
                    college performance for better placement readiness
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: 24,
                      height: 24,
                      bgcolor: "success.main",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 0.5,
                    }}
                  >
                    <Check sx={{ width: 16, height: 16, color: "white" }} />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "1.125rem", md: "1.25rem" },
                      color: "text.primary",
                      lineHeight: 1.75,
                    }}
                  >
                    Workshops and Doubt Clearing session to help build and
                    improve critical mistakes
                  </Typography>
                </Box>

                <Box sx={{ pt: 2 }}>
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "black",
                      "&:hover": { bgcolor: "grey.800" },
                      color: "white",
                      px: 6,
                      py: 2,
                      fontSize: "1.125rem",
                      borderRadius: "12px",
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    Request Demo
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
